import LabPage from "../components/layout/LabPage";
import { Mic, Wand2, AudioLines, Volume2, Music, Disc, FileAudio, Headphones } from "lucide-react";

export default function VoiceLab() {
  return (
    <LabPage
      testId="voice-lab-page"
      kicker="VoiceLab"
      title="Audiobook, narration, and voiceover"
      description="ElevenLabs-powered voice generation. Audiobooks, webinar narration, promotional voiceover, and chapter audio files — premium quality."
      heroImage="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=900&q=80"
      heroTone="aqua"
      actions={[{ label: "Generate Voiceover", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "Voice Library", icon: Mic },
        { label: "Pronunciation", icon: AudioLines },
        { label: "Intro / Outro", icon: Music },
        { label: "Chapter Audio", icon: Disc },
      ]}
      features={[
        { icon: Mic, title: "Audiobook Pipeline", description: "Send chapters from BookLab, generate, and export." },
        { icon: Volume2, title: "Voice Selection", description: "Curated premium voices, preview before generation." },
        { icon: AudioLines, title: "Pacing & Tone", description: "Speed, pause, emphasis controls per paragraph." },
        { icon: FileAudio, title: "Pronunciation Editor", description: "Custom pronunciations for names, brands, and terms." },
        { icon: Headphones, title: "Promo & Snippets", description: "Short voiceover for ads, reminders, hooks." },
        { icon: Disc, title: "Multi-Format Export", description: "MP3, WAV, chapter-separated or single audiobook file." },
      ]}
      sampleAssets={[
        { title: "Operator's Playbook · Ch.1", thumb: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=500&q=80", meta: "12:34 · MP3" },
        { title: "Webinar Promo VO", thumb: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=500&q=80", meta: "00:35" },
        { title: "Cart Close Reminder", thumb: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=500&q=80", meta: "00:18" },
        { title: "Challenge Day 1", thumb: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&q=80", meta: "08:42" },
      ]}
    />
  );
}
